import { businessOutline, heartOutline, homeOutline, locateOutline, locationOutline } from 'ionicons/icons';

export const KIND_ICONS = {
  home: homeOutline,
  work: businessOutline,
  couple: heartOutline,
  other: locationOutline,
  location: locateOutline
};
